import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { UserRole } from '../constants/keys.constant';

@Injectable({
  providedIn: 'root'
})
export class CreditBalanceInterceptor implements HttpInterceptor {
  /** AI-credit-consuming endpoints — a successful response from any of these refreshes the header balance. */
  private readonly creditConsumingUrlPatterns: RegExp[] = [
    /chatbot\/chat/i,
    /chatbot\/stream/i,
    /college\/university-search/i,
    /learningsessions\/?(?:[?#]|$)/i,
    /diagnostics\/start-session/i,
    /diagnostics\/retake-session/i,
    /essay\/generate-outline/i,
    /essay\/import-draft\/analyze/i,
    /essay\/ai-suggest/i,
    /essay\/health-check/i,
    /essay\/make-concise/i,
    /essay\/improve-clarity/i,
    /essay\/rephrase-selection/i,
    /interview\/create-session/i,
    /interview\/practice-session\/submit/i,
    /knowledgebank\/generate/i,
    /knowledgebank\/upload-file/i,
    /knowledgebank\/[^/?]+\/upload-file/i,
    /knowledgebank\/create/i,
    /knowledgebanklessonplans\/create/i,
    /knowledgebanklessonplans\/regenerate\/[^/?]+/i,
    /knowledgebanklessons\/create/i,
    /knowledgebanklessons\/student\/complete-subtopic/i,
    /knowledgebanklessons\/student\/evaluate-answer/i,
    /knowledgebankminiquizs\/create/i,
    /knowledgebankworksheets\/create/i
  ];

  constructor(private authService: AuthService) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && event.ok && this.isCreditConsumingUrl(req.url)) {
          this.refreshCreditBalance();
        }
      })
    );
  }

  private isCreditConsumingUrl(url: string): boolean {
    return this.creditConsumingUrlPatterns.some((pattern) => pattern.test(url));
  }

  /** Balance endpoint only exists for STUDENT/TUTOR/COUNSELOR — same gate as MainComponent.fetchCreditBalance. */
  private refreshCreditBalance(): void {
    const role = this.authService.currentProfileDetails?.role;
    if (role !== UserRole.STUDENT && role !== UserRole.TUTOR && role !== UserRole.COUNSELOR) {
      return;
    }
    this.authService.getCreditBalance().subscribe({
      next: (res) => this.authService.creditBalanceSubject.next(res)
    });
  }
}
